import React, { useState } from 'react'
import { JsonEditor } from 'jsoneditor-react'
import './style.css'
import 'jsoneditor-react/es/editor.min.css'
import ace from 'brace'
import 'brace/theme/github'
import 'brace/mode/json'
import { useTranslation } from 'react-i18next'
import { convertJSONToObject } from '../../../utils'
import { Button, Modal } from 'react-bootstrap'




const JsonEditorModal = ({ open, onClose, onSave, value, title }) => {
    const { t } = useTranslation()
    const [json, setJson] = useState(value)
    const [buttonDisabled, setButtonDisabled] = useState(true)
    const defaultValue = convertJSONToObject(json, value)

    const handleValidationError = (error) => {
        if (error.length > 0) {
            setButtonDisabled(true)
        }
    }
    const handleChange = (newJson) => {
        setJson(JSON.stringify(newJson))
        setButtonDisabled(false)
    }
    const handleSave = () => {
        try {
            onSave(json)
            onClose()
        } catch (error) {
            setButtonDisabled(true)
        }
    }
    return (
        <Modal
            show={open}
            onHide={onClose}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <span className='mr-2 text-capitalize'> {t(title)}</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <JsonEditor
                    value={defaultValue}
                    onChange={handleChange}
                    mode="code"
                    ace={ace}
                    search={true}
                    onValidationError={handleValidationError}
                    htmlElementProps={{ style: { height: '60vh', width: '100%' } }}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    {t('Close')}
                </Button>
                <Button variant="primary" onClick={handleSave} disabled={buttonDisabled}>
                    {t('Save')}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default JsonEditorModal
